var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "20px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "stat-card" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.stats.totalUsers || 0)),
                  ]),
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("Total Users"),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "stat-card" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.stats.todayActiveUsers || 0)),
                  ]),
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("Active Today"),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "stat-card" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.stats.last7DaysActiveUsers || 0)),
                  ]),
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("Active (7 Days)"),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "stat-card" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.stats.totalRecords || 0)),
                  ]),
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("Total Records"),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "250px" },
            attrs: { placeholder: "User ID", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleFilter.apply(null, arguments)
              },
            },
            model: {
              value: _vm.listQuery.userId,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "userId", $$v)
              },
              expression: "listQuery.userId",
            },
          }),
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "300px" },
            attrs: {
              type: "daterange",
              "range-separator": "-",
              "start-placeholder": "Start Date",
              "end-placeholder": "End Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.dateRange,
              callback: function ($$v) {
                _vm.dateRange = $$v
              },
              expression: "dateRange",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(" Search ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading...",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "User", align: "left", "min-width": "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", { staticStyle: { "font-weight": "500" } }, [
                      _vm._v(
                        _vm._s(row.firstName || "") +
                          " " +
                          _vm._s(row.lastName || "")
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: { "font-size": "12px", color: "#909399" },
                      },
                      [_vm._v(_vm._s(row.email || "-"))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: { "font-size": "11px", color: "#C0C4CC" },
                      },
                      [_vm._v(_vm._s(row.userId))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Steps", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(Number(row.totalSteps || 0).toLocaleString()) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Distance", align: "center", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.formatDistance(row.totalDistance)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Walking Time", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatTime(row.totalWalkingTimeSec)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Records", align: "center", width: "90" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(Number(row.recordCount || 0).toLocaleString()) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Last Activity", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.formatDate(row.lastActivityDate)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Actions",
              align: "center",
              width: "100",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewUser(row)
                          },
                        },
                      },
                      [_vm._v(" View ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.selectedUserLabel,
            visible: _vm.dialogVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-container",
              staticStyle: { "margin-bottom": "15px" },
            },
            [
              _c("el-date-picker", {
                staticClass: "filter-item",
                staticStyle: { width: "300px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": "Start Date",
                  "end-placeholder": "End Date",
                  "value-format": "yyyy-MM-dd",
                },
                model: {
                  value: _vm.detailDateRange,
                  callback: function ($$v) {
                    _vm.detailDateRange = $$v
                  },
                  expression: "detailDateRange",
                },
              }),
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.fetchUserDaily },
                },
                [_vm._v(" Search ")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.dailyData, border: "", fit: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Date", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(" " + _vm._s(row.date) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Steps", align: "center", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              Number(row.totalSteps || 0).toLocaleString()
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Distance", align: "center", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDistance(row.totalDistance)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Time", align: "center", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.formatTime(row.walkingTimeSec)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Records", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(" " + _vm._s(row.recordCount) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Eval", align: "center", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.isEvaluated
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "mini" } },
                              [_vm._v("Yes")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "info", size: "mini" } },
                              [_vm._v("No")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Point", align: "center", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.isEvaluated
                          ? _c("span", [_vm._v(_vm._s(row.point))])
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "New Loc.", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.isEvaluated
                          ? _c("span", [
                              _vm._v(_vm._s(row.newLocation ? "Yes" : "No")),
                            ])
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Crowded", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.isEvaluated
                          ? _c("span", [
                              _vm._v(_vm._s(row.isCrowded ? "Yes" : "No")),
                            ])
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "GPS Routes", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.encodedPolylines && row.encodedPolylines.length > 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "mini" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(row.encodedPolylines.length) +
                                    " route(s) "
                                ),
                              ]
                            )
                          : _c("span", { staticStyle: { color: "#C0C4CC" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "",
                  align: "center",
                  width: "90",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "info" },
                            on: {
                              click: function ($event) {
                                return _vm.handleViewRecords(row.date)
                              },
                            },
                          },
                          [_vm._v(" Details ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Records - " + _vm.recordsDate,
            visible: _vm.recordsDialogVisible,
            width: "950px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.recordsDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.recordsLoading,
                  expression: "recordsLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.recordsList,
                border: "",
                fit: "",
                size: "small",
                "max-height": "500",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Time", align: "center", width: "170" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(" " + _vm._s(_vm.formatDate(row.addedAt)) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Steps", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(" " + _vm._s(row.stepCount || 0) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Distance (m)", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(Number(row.distance || 0).toFixed(2)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "GPS", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.encodedPolylines
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "mini" } },
                              [_vm._v("Yes")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "info", size: "mini" } },
                              [_vm._v("No")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Source", align: "center", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type:
                                row.source === "device" ? "warning" : "success",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.source || "-") + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Cane ID", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(" " + _vm._s(row.caneId || "-") + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Sensor Data", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.sensorData
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showSensorData(row.sensorData)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " View (" +
                                    _vm._s(
                                      Array.isArray(row.sensorData)
                                        ? row.sensorData.length
                                        : 0
                                    ) +
                                    " readings) "
                                ),
                              ]
                            )
                          : _c("span", { staticStyle: { color: "#C0C4CC" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.recordsTotal > 0,
                expression: "recordsTotal > 0",
              },
            ],
            attrs: {
              total: _vm.recordsTotal,
              page: _vm.recordsQuery.page,
              limit: _vm.recordsQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.recordsQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.recordsQuery, "limit", $event)
              },
              pagination: _vm.fetchRecords,
            },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.recordsDialogVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Sensor Data",
            visible: _vm.sensorDialogVisible,
            width: "700px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.sensorDialogVisible = $event
            },
          },
        },
        [
          _c("pre", { staticClass: "sensor-json" }, [
            _vm._v(_vm._s(_vm.sensorDataJson)),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.sensorDialogVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }